import React from 'react'

import VisaIcon from '../../assets/payment_cards_icons/visa.png'
import MasterCardIcon from '../../assets/payment_cards_icons/mastercard.png'
import AmexIcon from '../../assets/payment_cards_icons/amex.png'
import DiscoverIcon from '../../assets/payment_cards_icons/discover.png'

const PAYMENT_CARDS = [
  {
    icon: VisaIcon,
    alt: 'visa',
  },
  {
    icon: MasterCardIcon,
    alt: 'mastercard',
  },
  {
    icon: AmexIcon,
    alt: 'american express',
  },
  {
    icon: DiscoverIcon,
    alt: 'discover',
  },
]

const PaymentCardsList = () => (
  <ul className="payment_cards_list">
    {PAYMENT_CARDS.map(({ icon, alt }) => (
      <li key={icon} className="payment_cards_list_item">
        <div className="payment_card_w_image">
          <img className="payment_card_image" src={icon} alt={alt} />
        </div>
      </li>
    ))}
  </ul>
)

export default PaymentCardsList
